export const PersonalDashboardRefetchQueries = [
  "TasksSummaryHeader",
  "SchedulingModal",
  "ActionItemsScheduling",
  "ActionItemsStaleTasks",
  "ActionItemsDelayFlags",
  "UpcomingTasks",
];
